<template>
<div class="note">
  <h2 class="note__title">{{title}}</h2>
  <PulseLoader class="loading-indicator" v-if="!note"></PulseLoader>
  <form class="note__form" @submit.prevent="saveNote" v-if="note">
    <textarea class="note__editor" v-model="note.text"></textarea>
    <div class="note__bar">
      <span class="note__message" :class="message.type">{{message.text}}</span>
      <input class="note__submit pure-button" type="submit" value="Save" />
    </div>
  </form>
</div>
</template>
<script type="text/javascript">
  import PulseLoader from "vue-spinner/src/PulseLoader";
  import api from "../api";

  export default {
    name: "note",
    data() {
      return {
        note: null,
        message: {
          text: null,
          type: "",
        },
      };
    },
    props: {
      year: {
        type: Number,
        // required: true,
      },
      month: {
        type: Number,
        // required: true,
      },
      date: {
        type: Number,
        // required: true,
      },
    },
    computed: {
      title() {
        return `${this.dateObj.toDateString()}`;
      },
      dateObj() {
        const note = this;
        return new Date(note.year, note.month - 1, note.date);
      },
    },
    watch: {
      year() { this.getNote(); },
      month() { this.getNote(); },
      date() { this.getNote(); },
    },
    methods: {
      saveNote() {
        const note = this;
        note.flashMessage("Saving...", "success");
        api.saveNote(this.note).then((response) => {
          console.log("Note saved", response);
          note.flashMessage("Note saved 👍", "success");
        }).catch((error) => {
          console.log("Note save failed", error);
          note.flashMessage("Failed to save. 😞", "error");
        });
      },
      getNote() {
        const note = this;
        note.note = null;
        api.getNote(this.dateObj).then((response) => {
          note.note = response;
        });
      },
      flashMessage(text, type) {
        const note = this;
        note.message = { text, type };
        setTimeout(() => { note.message = { text: null, type: null }; }, 3000);
      },
    },
    created() {
      this.getNote();
    },
    components: {
      PulseLoader,
    },
  };
</script>
<style lang="scss">
.note__title {
  text-indent: 1em;
  margin: 0.5em auto;
  font-size: 1.2em;
}
.note__editor {
  width: 100%;
  min-height: 12em;
  border: 1px solid #888;
  display: block;
}
.note__submit {
  float: right;
  background: #03a9f4;
  color: #FFF;
}
.note__form {
  width: 100%;
  padding: 0 1%;
}
.note__bar {
  margin-top: 0.5em;
  text-align: right;
}
.note__message {
  font-size: 0.9em;
  padding-right: 1em;
  &.success {
    color: green;
  }
  &.error {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// Note.vue?19d0be12